export default {
  path: '/oms',
  component: (resolve) => require(['@/views/oms/index.vue'], resolve),
  redirect: '/oms/monitor-system/task-list',
  children: [
    {
      path: '/oms/monitor-system/task-list',
      component: (resolve) => require(['@/views/oms/monitor-system/task-list/index.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/task-list/:taskId',
      component: (resolve) =>
        require(['@/views/oms/monitor-system/task-list/TaskDetail.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/event-list',
      component: (resolve) => require(['@/views/oms/monitor-system/event-list/index.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/event-list/:eventId',
      component: (resolve) =>
        require(['@/views/oms/monitor-system/event-list/EventDetail.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/routers',
      component: (resolve) => require(['@/views/oms/devices-monitor/routers/index.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/routers/:routerId',
      component: (resolve) => require(['@/views/oms/devices-monitor/routers/items.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/switches',
      component: (resolve) => require(['@/views/oms/devices-monitor/switches/index.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/switches/:switchId',
      component: (resolve) => require(['@/views/oms/devices-monitor/switches/items.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/rack-current',
      component: (resolve) =>
        require(['@/views/oms/devices-monitor/rack-current/index.vue'], resolve)
    },
    {
      path: '/oms/system-behavior/operation-logs',
      component: (resolve) =>
        require(['@/views/oms/system-behavior/operation-logs/index.vue'], resolve)
    },
    {
      path: '/oms/system-behavior/audit',
      component: (resolve) => require(['@/views/oms/system-behavior/audit/index.vue'], resolve)
    },
    {
      path: '/oms/bare-metals/bare-metal-monitor/process-list',
      component: (resolve) =>
        require(['@/views/oms/bare-metals/bare-metal-monitor/process-list/index.vue'], resolve)
    },
    {
      path: '/oms/bare-metals/bare-metal-monitor/processed-list',
      component: (resolve) =>
        require(['@/views/oms/bare-metals/bare-metal-monitor/processed-list/index.vue'], resolve)
    },
    {
      path: '/oms/bare-metals/bare-metal-monitor/white-list',
      component: (resolve) =>
        require(['@/views/oms/bare-metals/bare-metal-monitor/white-list/index.vue'], resolve)
    },
    {
      path: '/oms/bare-metals/bare-metal-monitor/port-manage',
      component: (resolve) =>
        require(['@/views/oms/bare-metals/bare-metal-monitor/port-manage/index.vue'], resolve)
    },
    {
      path: '/oms/k8s-clouds/cloud-monitor/cloud-pack',
      component: (resolve) =>
        require(['@/views/oms/k8s-clouds/cloud-monitor/CloudPack.vue'], resolve)
    },
    {
      path: '/oms/k8s-clouds/cloud-monitor/:cloudId/nodelist',
      component: (resolve) =>
        require(['@/views/oms/k8s-clouds/cloud-monitor/CloudList.vue'], resolve)
    },
    {
      path: '/oms/k8s-clouds/cloud-monitor/:cloudId/:nodeName/pod-list',
      component: (resolve) => require(['@/views/oms/k8s-clouds/cloud-monitor/PodList.vue'], resolve)
    },
    {
      path: '/oms/api-limiting/api-limiting-rules',
      component: (resolve) =>
        require(['@/views/oms/api-limiting/api-limiting-rules/index.vue'], resolve)
    },
    {
      path: '/oms/api-limiting/block-record-management',
      component: (resolve) =>
        require(['@/views/oms/api-limiting/block-record-management/index.vue'], resolve)
    }
  ]
};
